import { startAnalytics } from "../../veson/analytics";
window.startAnalytics = startAnalytics;

$(function () {
    $.getJSON("/Account/GetLoginPromoConfig", function (data) {

        const veslinkCdn = window.__veslink_cdn__ || "/";

        // Set the background
        if (data.background) {
            $("#promo").css("background-image", `url(${veslinkCdn}Static/images/login/` + data.background + ")");
        }

        // Horizontally align the content   
        if (data.halign) {
            $("#promo > .content").css("text-align", data.halign);

            // If width is narrow and halign is left
            if (data.width == "narrow" && data.halign == "left") {
                $("#promo > .content").addClass("padding-right");
            }

            // If width is narrow and halign is right
            if (data.width == "narrow" && data.halign == "right") {
                $("#promo > .content").addClass("padding-left");
            }
        }

        // Vertically align the content  
        if (data.valign) {
            $("#promo > .content").css("vertical-align", data.valign);
        }

        // change the right padding
        if (data.rpadding) {
            $("#promo").css("padding-right", data.rpadding);
        }

        // Add the banner
        if (data.banner) {
            $("#promo > .content > .banner").attr("src", `${veslinkCdn}Static/images/login/` + data.banner);
        }

        // Size the banner
        if (data.bannersize) {
            if (data.bannersize == "small") {
                $("#promo > .content > .banner").addClass("small");
            }
            else {
                $("#promo > .content > .banner").addClass("large");
            }
        }

        // Add the title text
        if (data.title) {
            $("#promo > .content > .title").text(data.title);
        }

        // Add the sub title text
        if (data.subtitle) {
            $("#promo > .content > .subtitle").text(data.subtitle);
        }

        // Add the cta link
        if (data.ctalink) {
            $("#promo > .content").attr("href", data.ctalink).attr("target", "_blank");
        }

        // Add theme
        if (data.theme == "white") {
            $("#promo > .content").addClass("white");
        }

    });

    $("#username").focus();

    $("#forget-password-link").click(function(){
        $("#forget-password-popup").addClass("visible");
        $("#forget-password-email").focus();
    });

    $("#forget-password-cancel").click(function(e){
        $("#forget-password-popup").removeClass("visible");
        e.stopPropagation();
        e.preventDefault();
    });

    $("#forget-password-submit").click(function(e){
        sendForgotPasswordEmail();
        e.stopPropagation();
        e.preventDefault();
    });

    function sendForgotPasswordEmail() {
        var email = $("#forget-password-email").val();

        if (email == "") {
            setPasswordMessage("Please enter a valid email address.");
            return;
        }

        $('#forget-password-submit').attr("disabled", "disabled");
        $.ajax({
            type: "POST",
            url: "/Account/ForgotPassword",
            data: { email: email },
            dataType: "json",
            success: function(data) {
                setPasswordMessage(data.message);
                $("#forget-password-submit").removeAttr("disabled");
                $("#forget-password-email").attr("value", "");
            },
            error: function() {
                $("#forget-password-submit").removeAttr("disabled");
                setPasswordMessage("An unexpected error has occured sending your new password. Please access our Help Center at https://vesonjira.atlassian.net/servicedesk/customer/portals");
            }
        });
    }

    function setPasswordMessage(message) {
        // Remove any existing message and display new one.
        $("#forget-password-warning").html(message).fadeIn();
    }

    function setInitialLoginFlag() {
        localStorage.setItem("initialLogin", true);
    }

    // Single Sign On or ImosX sign in
    function ssoCheck() {
        var email = $("#username").val(),
            atIndex = email.indexOf("@"),
            dotIndex = email.lastIndexOf(".");
        //Simple check looking for basic email structure with a . somewhere after an (at) symbol so we don't do the check all the time.
        if (!(atIndex < dotIndex && atIndex != -1)) {
            if (!$("#password").is(":visible")) {
                $("#password").val("");
                $("#sso-text").hide();
                $("#login-button").val("Log In");
                toggleVisibleFields();
            }
            return;
        }

        $.ajax({
            type: "POST",
            url: "/Account/SSOCheck",
            data: { email: email },
            dataType: "json",
            success: function (response) {
                if (response.sso) {
                    // Don't toggle if we don't need to
                    if ($("#password").is(":visible")) {
                        $("#password").val("0"); // Hack to bypass form validation
                        $("#sso-text").show();
                        $("#login-button").val("Continue");
                        toggleVisibleFields();
                    }
                } else if (response.imosXAuthenticationEnabled) {
                    // Don't toggle if we don't need to
                    if ($("#password").is(":visible")) {
                        $("#password").val("0"); // Hack to bypass form validation
                        $("#sso-text").hide();
                        $("#login-button").val("Continue");
                        toggleVisibleFields();
                    }
                } else {
                    if (!$("#password").is(":visible")) {
                        $("#password").val("");
                        $("#sso-text").hide();
                        $("#login-button").val("Log In");
                        toggleVisibleFields();
                    }
                }
                $("#SSO").val(response.sso);
            },
            error: function (_, status, e) {
                console.error("Error checking SSO status: " + status + " - " + e);
            }
        });
    }

    function toggleVisibleFields() {
        $("#password").toggle();
        $("#remember-me-container").toggle();
    }

    $("#username").bind("change keyup blur", ssoCheck);

    setInitialLoginFlag();
    ssoCheck();
    // clear out any leftover parner company association 
    // copied from networkPartners.js to avoid JS dependency mess
    sessionStorage.removeItem("partnerCompanyCode");
    $.removeCookie("PartnerCompanyCode", { path: '/' });
});